import React from 'react'
import PropTypes from 'prop-types'

const FactorOption = ( { img, title, description = '', bold = false, width = '32', height = '32', setupAriaDescription = '', onSetUpClick, setupOption = false, setUpId= '' } ) => {
  return (
      <>
          <div className='text-message-verify mb-4'>
              <img src={ img } height= { `${ height }px` } width= { `${ width }px` } alt='Icon' className='mr-4' />
              <div className='mr-5'><label className={ `text-message-wrap-text ${ bold ? 'text-message-verify--label' : 'text-message-verify--label--regular' }` } aria-label={ title } tabIndex='0'>{ title }</label></div>
              { setupOption && <button id={ setUpId } tabIndex='0' onClick = { onSetUpClick } aria-label={ setupAriaDescription } className='text-message-verify--label--setup u-btn-clear'>Set Up</button> }
          </div>
          { description !== '' && <div className='mb-6'>
              <label tabIndex='0' className='mb-0 c-mfa-label--content' aria-label={ description }>{ description }</label>
          </div> }
      </> 
  )
}

export default FactorOption

FactorOption.propTypes = {
    img: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    bold: PropTypes.bool,
    height: PropTypes.string,
    width: PropTypes.string,
    setupAriaDescription: PropTypes.string,
    onSetUpClick: PropTypes.func,
    setupOption: PropTypes.bool,
    setUpId: PropTypes.string
}
